import * as MD from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import _ from 'lodash';
import { IApplicationState } from '../../Store';
import { I18N, ILocaleInfos } from '../../Store/I18n/Types';
import { History } from 'history';
import { IUserState } from '../../Store/User/Types';
import { showDrawer } from '../../Store/Layout/Actions';
import { IStatsFilters1, IStatsFilters2, IStatsFilters3, IStatsFilters4, IStatsFilters5, IStatsState, topTitles } from '../../Store/Statistics/Types';
import { ISearchState } from '../../Store/Search/Types';
import { getStatisticsStep1, getStatisticsStep2, getStatisticsStep3, getStatisticsStep4, getStatisticsStep5, resetStats} from '../../Store/Statistics/Actions';
import { ILayoutState } from '../../Store/Layout/Types';
import { RouteComponentProps } from 'react-router-dom';
import { PieChart } from './PieChart';
import { TypedStorage } from '../../Utils/TypedStorage';
import { BarChart } from './BarChart';
import { TableDetails } from '../TableDetails';
import { convertColor } from '../../Utils/Various';
import { withStyles } from '@material-ui/core/styles';
import { getTheme } from '../../Themes';
import { IDashboardState } from '../../Store/Dashboard/Types';

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(MD.StepConnector);

const theme = getTheme()

const styles = (theme:any) => MD.createStyles({
  ifilters:{
    fontSize: 'small',
    fontWeight: 500,
    backgroundColor: theme.palette.background.paper,
    display: 'inline-flex',
    padding: '10px 10px 5px',
    marginBottom: '10px',
    position: 'fixed',
    top: 40,
    left: 0,
    width: '100%',
    zIndex: 1200
  },
  active: {
      color: '#7863e0',
      fill: '#7863e0'
  },
  text: {
      fill: 'white'
  },
  stepper: {
      marginTop: 10,
      marginBottom: 10,
      paddingTop: 10,
      paddingBottom: 5,
      width: '99%'
  }
});

interface IPropsFromState {
    i18n: I18N;
    localeInfos: ILocaleInfos;
    history: History;
    user: IUserState;
    stats: IStatsState;
    search: ISearchState;
    layout: ILayoutState;
    dashboard: IDashboardState;
    router: RouteComponentProps<{}>;
}

interface IPropsFromDispatch {
  showDrawer: typeof showDrawer
  getStatisticsStep1: typeof getStatisticsStep1
  getStatisticsStep2: typeof getStatisticsStep2
  getStatisticsStep3: typeof getStatisticsStep3
  getStatisticsStep4: typeof getStatisticsStep4
  getStatisticsStep5: typeof getStatisticsStep5
  resetStats: typeof resetStats
}

interface IState {
  pageActive: number;
  maxPageActive: number;
  showPercent: boolean;
  showRepReg: boolean;
  isFirstLoaded: boolean;
  // medias
  mediasID: number[] | null;
  mediasStr: string[];
  isAllMediasSelected: boolean;
  // program types state
  programTypesID: number[] | null;
  programTypesStr: string[];
  isAllProgramTypesSelected: boolean;
  // program editors state
  programEditorsID: number[] | null;
  programEditorStr: string[];
  isAllProgramEditorsSelected: boolean;
  startDate: Date;
  endDate: Date;
  dateCloture: any;
}

type AllProps =
    MD.WithTheme &
    MD.WithStyles &
    IPropsFromState &
    IPropsFromDispatch;

export class StatisticsRepartitionContentComponent extends React.Component<AllProps, IState> {
    
    public constructor(props: AllProps) {
        super(props);
        let endDate = new Date()
        this.state = {
          pageActive: 0,
          maxPageActive: 0,
          showPercent: false,
          showRepReg: false,
          isFirstLoaded: false,
          mediasID: null,
          mediasStr: [],
          isAllMediasSelected: true,
          programTypesID: null,
          programTypesStr: [],
          isAllProgramTypesSelected: true,
          programEditorsID: null,
          programEditorStr: [],
          isAllProgramEditorsSelected: true,
          startDate: new Date(endDate.getFullYear(), endDate.getMonth(), 1),
          endDate: endDate,
          dateCloture: null
        }
    }

    static getDerivedStateFromProps(props: AllProps, state: IState) {
      const pathParts = props.router.location.pathname.split('/');
      if (props.search.allProgramTypesID.length > 0 && props.user.allMediasID.length > 0
        && pathParts[1] === 'statistics' && ! state.isFirstLoaded) { 
        state.isFirstLoaded = true
      }
      if (TypedStorage.get('politicalRegimeId', 0) !== 0 && props.stats.statsFilters1 !== null && props.stats.totalDurationS !== undefined) {
        props.getStatisticsStep2({
          startDate: props.stats.statsFilters1.startDate,
          endDate: props.stats.statsFilters1.endDate,
          mediasIds: props.stats.statsFilters1.mediasIds,
          programTypesIds: props.stats.statsFilters1.programTypesIds,
          political_regime_id: TypedStorage.get('politicalRegimeId', 0)
        }, 
          props.stats.totalDurationS,
          TypedStorage.get('politicalRegimeName', ''),
          TypedStorage.get('politicalRegimeColor', 0)
        )
        state.pageActive = 1
        state.maxPageActive = 1
          
        TypedStorage.del('politicalRegimeId');
        TypedStorage.del('politicalRegimeName');
        TypedStorage.del('politicalRegimeColor')
      }
      if (TypedStorage.get('politicalGroupId', 0) !== 0 && props.stats.statsFilters1 !== null) {
        props.getStatisticsStep3({
          startDate: props.stats.statsFilters1.startDate,
          endDate: props.stats.statsFilters1.endDate,
          political_group_id: TypedStorage.get('politicalGroupId', 0),
          mediasIds: props.stats.statsFilters1.mediasIds,
          programTypesIds: props.stats.statsFilters1.programTypesIds
        }, 
          TypedStorage.get('politicalGroupName', ''),
          TypedStorage.get('politicalGroupColor', 0)
        )
        state.pageActive = 2
        state.maxPageActive = 2        

        TypedStorage.del('politicalGroupId');
        TypedStorage.del('politicalGroupName');
        TypedStorage.del('politicalGroupColor');
      }
      if (TypedStorage.get('personId', 0) !== 0 && props.stats.statsFilters1 !== null && props.stats.statsFilters3 !== null) {
        props.getStatisticsStep4({
          political_group_id: props.stats.statsFilters3.political_group_id,
          startDate: props.stats.statsFilters1.startDate,
          endDate: props.stats.statsFilters1.endDate,
          person_id: TypedStorage.get('personId', 0),
          mediasIds: props.stats.statsFilters1.mediasIds,
          programTypesIds: props.stats.statsFilters1.programTypesIds
        }, 
          TypedStorage.get('personName', ''),
          TypedStorage.get('personColor', 0)
        )
        state.pageActive = 3
        state.maxPageActive = 3
          
        TypedStorage.del('personId');
        TypedStorage.del('personName');
        TypedStorage.del('personColor');
      }
      if (TypedStorage.get('mediaId', 0) !== 0 && props.stats.statsFilters1 !== null 
      && props.stats.statsFilters3 !== null && props.stats.statsFilters4 !== null && props.stats.statsFilters2 !== null) {
        props.getStatisticsStep5({
          media_id: TypedStorage.get('mediaId', 0),
          political_group_id: props.stats.statsFilters3.political_group_id,
          political_regime_id: props.stats.statsFilters2.political_regime_id,
          startDate: props.stats.statsFilters1.startDate,
          endDate: props.stats.statsFilters1.endDate,
          person_id: props.stats.statsFilters4.person_id,
          program_type_ids: props.stats.statsFilters1.programTypesIds
        }, 
          TypedStorage.get('mediaName', ''))
        state.pageActive = 4
        state.maxPageActive = 4
          
        TypedStorage.del('mediaId');
        TypedStorage.del('mediaName');
      }
      if (props.search.allProgramTypesID.length > 0 && state.programTypesID === null) {
        state.programTypesID = props.search.allProgramTypesID
        state.programTypesStr = props.search.allProgramTypesSTR
      }
      if (props.user.allMediasID.length > 0 && state.mediasID === null) {
          state.mediasID = props.user.allMediasID
          state.mediasStr = props.user.allMediasSTR
      }
      if (props.search.allProgramEditorsID !== null && props.search.allProgramEditorsID.length > 0 && state.programEditorsID === null) {
          state.programEditorsID = props.search.allProgramEditorsID
          state.programEditorStr = props.search.allProgramEditorsSTR
      }
      if (props.stats.isLoadingStats1) {
        state.pageActive = 0
        state.maxPageActive = 0
      }
      if (props.dashboard.dateCloture !== null && state.dateCloture === null) {
        let endDate = props.dashboard.dateCloture
        state.startDate = new Date(endDate.getFullYear(), endDate.getUTCMonth(), 1)
        state.endDate = endDate
        state.dateCloture = endDate
      }
      return state
    }

    componentDidMount() {
      if (!this.props.layout.showDrawer) {
        this.props.showDrawer();
      }
    }

    public componentDidUpdate(prevProps: AllProps, prevState:IState){
      if ( prevProps.stats.statsFilters1 !== null && this.props.stats.statsFilters1 !== null) {
        if (!_.isEqual(prevProps.stats.statsFilters1?.mediasIds, this.props.stats.statsFilters1?.mediasIds)) {
          this.setState({
              mediasStr: this.props.stats.statsFilters1.mediasStr
          })
        }
        if (!_.isEqual(prevProps.stats.statsFilters1.programTypesIds, this.props.stats.statsFilters1.programTypesIds)) {
          this.setState({
              programTypesStr: this.props.stats.statsFilters1.programTypesStr
          })
        }
        if (!_.isEqual(prevProps.stats.statsFilters1.startDate, this.props.stats.statsFilters1.startDate)) {
          this.setState({
              startDate: this.props.stats.statsFilters1.startDate
          })
        }
        if (!_.isEqual(prevProps.stats.statsFilters1.endDate, this.props.stats.statsFilters1.endDate)) {
          this.setState({
              endDate: this.props.stats.statsFilters1.endDate
          })
        }
      }
    }

    public getSnapshotBeforeUpdate(prevProps: AllProps, prevState:any){
      
      return null;
    }

    private drawPieChart(data: any, chartId: string, category: string, value: string, title:string, chartName:string, titleColor?: string) {
      const { history } = this.props;
        return(
            <PieChart 
            data={data} 
            category={category}
            value={value}
            title={title}
            titleColor={titleColor}
            chartName={chartName}
            history={history} 
            chartId={chartId}  
            buildStepper={() => this.buildStepper()}
            />
        )
    }

    private drawBarChart(data: any, chartId: string, category: string, value: string, title:string, chartName: string, titleColor: string) {
      const { history } = this.props;
        return(
            <BarChart 
            data={data} 
            category={category}
            value={value}
            title={title}
            titleColor={titleColor}
            chartName={chartName}
            history={history} 
            chartId={chartId}  
            buildStepper={() => this.buildStepper()}
            />
        )
    }

    private buildTitle() {
      return(
          <div style={{display: 'block', width: '50%'}}>
            <span>
                Interventions
            </span>
            <div style={{color: theme.palette.primary.main, textTransform: 'capitalize'}}>
                {this.props.stats.personName}
            </div>
        </div>
      )
    }

    private handleStep(step: number, ev: any) {
      this.setState({pageActive: step});
    }

    private buildStepper() {
      const { classes } = this.props;
      return (
          <div className={classes.root}>
              <MD.Stepper activeStep={this.state.pageActive} alternativeLabel nonLinear 
              connector={<QontoConnector />}
              className={classes.stepper}>
              {this.props.stats.activeTabNames.map((tab) => {
                return (
                    <MD.Step key={tab.name}>
                      <MD.StepButton
                      onClick={this.handleStep.bind(this, tab.id)}
                    >
                      <MD.StepLabel
                      StepIconProps={{
                        classes: {
                            text: classes.text
                        }
                      }}>
                            {tab.name}
                      </MD.StepLabel> 
                    </MD.StepButton>
                  </MD.Step>
                )
              })
              }
          </MD.Stepper>
          </div>
      )
    }

    private drawTableDetails() {
      return(
        <>
          <div style={{display: 'inline-flex', width: '100%'}}>
            { this.buildTitle() }
          </div>
          { this.buildStepper() }
          <TableDetails
              data={this.props.stats.statsStep5}
              hideMediaFilter={true}
              type={'statistics'}
          />
        </>
      )
    }

    componentWillUnmount() {
      this.props.resetStats()
    }
    public render(): React.ReactNode {
        const { stats, i18n } = this.props
        return (
          <div style={{paddingTop: 20, display: 'inherit'}}>     
            
            { this.state.pageActive === 0 && stats.dataRegime === null && !stats.isLoadingStats1 &&
            <span>
              {i18n._('Please select filters')}
            </span>
            }
            { this.state.pageActive === 0 && stats.dataRegime === null && stats.isLoadingStats1 &&
               <span>
                  {i18n._('Loading')}...
               </span>
            }
            { this.state.pageActive === 0 && stats.dataRegime !== null && stats.dataRegime.length === 0 
            && !stats.isLoadingStats1 &&
            <span>
              {i18n._('No results')}
            </span>
            }
            { this.state.pageActive === 0 && stats.dataRegime !== null 
            && stats.periodTitle !== undefined && stats.dataRegime.length > 0 &&
            ! stats.isLoadingStats1 &&
              this.drawPieChart(stats.dataRegime, "chartRegime", "political_regime_name", "percent", '', topTitles[0].name) 
            }
            { this.state.pageActive === 1 && (stats.dataGroup === null || stats.isLoading) &&
               <span>
                  {i18n._('Loading')}...
               </span>
            }
            { this.state.pageActive === 1 && stats.dataGroup !== null && stats.dataGroup.length === 0 &&
            <span>
              {i18n._('No results')}
            </span>
            }
            { 
              this.state.pageActive === 1 &&
              stats.dataGroup !== null && stats.dataGroup.length > 0 &&
              ! stats.isLoading &&
              this.drawPieChart(stats.dataGroup, "chartGroup", "political_group_name", "percent", stats.regimeName, 'partis politiques', convertColor(stats.regimeColor))
            }
            { this.state.pageActive === 2 && (stats.dataPerson === null || stats.isLoading) &&
               <span>
                  {i18n._('Loading')}...
               </span>
            }
            { this.state.pageActive === 2 && stats.dataPerson !== null && stats.dataPerson.length === 0 &&
            <span>
              {i18n._('No results')}
            </span>
            }
            { 
              this.state.pageActive === 2 &&
              stats.dataPerson !== null && stats.dataPerson.length > 0 &&
              ! stats.isLoading &&
              this.drawBarChart(stats.dataPerson, "chartPerson", "person_name", "duration", stats.groupName, 'intervenants', convertColor(stats.groupColor))
            }
            { this.state.pageActive === 3 && (stats.dataMedia === null || stats.isLoading) &&
              <span>
                {i18n._('Loading')}...
              </span>
            }
            { this.state.pageActive === 3 && stats.dataMedia !== null && stats.dataMedia.length === 0 &&
            <span>
              {i18n._('No results')}
            </span>
            }
            { 
              this.state.pageActive === 3 &&
              stats.dataMedia !== null && stats.dataMedia.length > 0 &&
              ! stats.isLoading &&
              this.drawPieChart(stats.dataMedia, "chartMedia", "media_name", "percent", stats.personName, 'medias', convertColor(stats.personColor))
            }
            { this.state.pageActive === 4 && (stats.dataDay === null || stats.isLoading) &&
              <span>
                {i18n._('Loading')}...
              </span>
            }
            { this.state.pageActive === 4 && stats.dataDay !== null && stats.dataDay.length === 0 &&
            <span>
              {i18n._('No results')}
            </span>
            }
            {
              this.state.pageActive === 4 &&
              stats.dataDay !== null && stats.dataDay.length > 0 &&
              ! stats.isLoading &&
              this.drawTableDetails()
            }
        </div>
      )
    }
  }

    

const mapStateToProps = ({i18n, user, stats, search, layout, dashboard} : IApplicationState, ownProps: RouteComponentProps<{}>) => {
  return {
    i18n: i18n.i18n,
    localeInfos: i18n.localeInfos,
    user: user,
    stats,
    search,
    layout,
    dashboard,
    router: ownProps
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  showDrawer: () => dispatch(showDrawer()),
  getStatisticsStep1: (filters: IStatsFilters1, periodTitle: string | undefined) => dispatch(getStatisticsStep1(filters, periodTitle)),
  getStatisticsStep2: (filters: IStatsFilters2, total_duration_s: number,  regimeName?: string, regimeColor?: number) => dispatch(getStatisticsStep2(filters, total_duration_s, regimeName, regimeColor)),
  getStatisticsStep3: (filters: IStatsFilters3, groupName?: string, groupColor?: number) => dispatch(getStatisticsStep3(filters, groupName, groupColor)),
  getStatisticsStep4: (filters: IStatsFilters4, personName?: string, personColor?: number) => dispatch(getStatisticsStep4(filters, personName, personColor)),
  getStatisticsStep5: (filters: IStatsFilters5, mediaName?: string) => dispatch(getStatisticsStep5(filters, mediaName)),
  resetStats: () => dispatch(resetStats())
});

export const StatisticsRepartitionContent = 
    connect(mapStateToProps, mapDispatchToProps)
    (MD.withTheme(MD.withStyles(styles)(StatisticsRepartitionContentComponent)));
